function MotionBtn(props) {

    const handleMotion = () => {
        if (props.isMovementOn === true){
            props.setIsMovementOn(false);
        }
        else{
            props.setIsMovementOn(true);
        }
    };

    return(
        <div style={{display: (props.width < 1000) ?  'none' : 'block'}} className="motion-btn-container" onClick={() => handleMotion()}>
            <div id={props.isMovementOn ? "motion-btn-on" : "motion-btn-off"}>{props.isMovementOn ? "Click here to turn motion off.": "Click here to turn motion on."}</div>
        </div>
    )
}

export default MotionBtn;